<app-new-modal-body>
    <form [formGroup]="form" class="tw:text-center tw:p-4" (ngSubmit)="submit()">
        <h6 class="tw:h6 tw:mb-6 tw:w-full tw:text-center tw:text-primary-500">{{ 'INVOICE_PREVIEW.editPayments' | translate }}</h6>

        <div class="tw:flex tw:flex-col tw:text-left tw:mb-2" formArrayName="payments">
            @for (paymentCtrl of paymentsArray.controls; let i = $index; track i) {
                <div [formGroupName]="i" class="tw:mb-4 tw:p-4 tw:bg-primary-50 tw:rounded-xl">
                    <div class="tw:mb-4 tw:grid tw:gap-4 tw:grid-cols-2">
                        <div>
                            <div class="tw:font-semibold tw:text-neutral-500">{{ 'INVOICE_PAYMENT_METHOD.payment' | translate }}</div>
                            <div class="tw:font-semibold tw:text-sm">{{ data.payments[i].paidAt | date }}</div>
                        </div>
                        <div>
                            <div class="tw:font-semibold tw:text-neutral-500">{{ 'INVOICE_PAYMENT_METHOD.value' | translate }}</div>
                            <div class="tw:font-semibold tw:text-sm">{{ data.payments[i].amount | merchantCurrency }}</div>
                        </div>
                    </div>
                    <app-dropdown-input-v2 formControlName="paymentMethod"
                        label="{{ 'INVOICE_PAYMENT_METHOD.paymentMethod' | translate }}"
                        [options]="paymentMethods"
                        textOption="label"
                        placeholder="{{ 'INVOICE_PAYMENT_METHOD.paymentMethod' | translate }}"
                     />
                </div>
            }
        </div>
    
        <div class="tw:flex tw:justify-center tw:items-center tw:gap-2">
            <app-button buttonType="submit" [disabled]="!paymentsArrayHasEnableFields" [loading]="saving()" extraClass="w-full"> {{ 'GENERAL.save' | translate }} </app-button>
            <app-button type="secondary" (clickEvent)="close()" extraClass="w-full"> {{ 'GENERAL.cancel' | translate }} </app-button>
        </div>
    </form>
</app-new-modal-body>
